<template>
  <el-dialog
    title="配置专业解读视频"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form label-position="left" label-width="90px">
      <el-form-item label="视频链接">
        <el-input clearable v-model="video"></el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button plain @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getSchoolVideo, putSchoolVideo } from '@/api/pick_school';
import { validateURL } from '@/utils/validate';
export default {
  name: 'DialogVideo',
  data() {
    return {
      dialogVisible: false,
      uuid: '',
      video: '',
    };
  },
  methods: {
    show(uuid) {
      this.dialogVisible = true;
      this.uuid = uuid;
      getSchoolVideo(uuid).then(res => {
        this.video = res.data.video || '';
      });
    },
    onConfirm() {
      const { video } = this;
      if (video && !validateURL(video)) {
        return this.$message.error('请输入合法链接');
      }
      this.$confirm('确认修改视频链接吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          putSchoolVideo(this.uuid, {
            video,
          }).then(() => {
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            });
            this.dialogVisible = false;
          });
        })
        .catch(() => {});
    },
    handleClose() {},
  },
};
</script>

<style></style>
